import BaseService from './base.service';

class QualityEvaluationService extends BaseService {
  /**
   * Create a new quality evaluation
   * @param {Object} data - The evaluation data
   * @returns {Promise} - The created evaluation
   */
  create(data) {
    return this.post('quality-evaluation', data);
  }

  /**
   * Get all quality evaluations
   * @returns {Promise} - List of evaluations
   */
  getAll() {
    return this.get('quality-evaluation');
  }

  /**
   * Get a quality evaluation by ID
   * @param {number} id - The evaluation ID
   * @returns {Promise} - The evaluation data
   */
  getById(id) {
    return this.get(`quality-evaluation/${id}`);
  }

  /**
   * Get a quality evaluation by observation ID using the observation endpoint
   * @param {number} observationId - The observation ID
   * @returns {Promise} - The evaluation data with observation
   */
  getByObservationId(observationId) {
    return this.get(`quality-evaluation/observation/${observationId}`);
  }

  /**
   * Update a quality evaluation
   * @param {number} id - The evaluation ID
   * @param {Object} data - The updated evaluation data
   * @returns {Promise} - The updated evaluation
   */
  update(id, data) {
    return this.patch(`quality-evaluation/${id}`, data);
  }

  /**
   * Submit answers for a quality evaluation
   * @param {number} id - The evaluation ID
   * @param {Object} answers - The answers object with question IDs as keys and selected option IDs as values
   * @returns {Promise} - The updated evaluation data
   */
  submitAnswers(id, answers) {
    // Send answers directly without wrapping in another object
    return this.patch(`quality-evaluation/${id}/submit-answers`, answers);
  }

  /**
   * Delete a quality evaluation
   * @param {number} id - The evaluation ID
   * @returns {Promise} - The deletion result
   */
  remove(id) {
    return this.delete(`quality-evaluation/${id}`);
  }

  /**
   * Update questions for a quality evaluation by observation ID
   * @param {number} observationId - The observation ID
   * @param {Object} data - Object containing questions array to update
   * @returns {Promise} - The updated evaluation data
   */
  updateQuestions(observationId, data) {
    return this.patch(`quality-evaluation/observation/${observationId}/questions`, data);
  }
}

export default new QualityEvaluationService();
